import { render } from "./CampoTextoLectura.vue?vue&type=template&id=028784ab"
import script from "./CampoTextoLectura.vue?vue&type=script&lang=js"
export * from "./CampoTextoLectura.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__